(function () {
    'use strict';

    angular
        .module('riskModule')
        .controller('ShowRiskAssessmentRatingsLegendController', Controller);

    Controller.$inject = ['$scope', 'commonRiskSelfAssessmentService'];

    function Controller($scope, service) {

        $scope.lookupTypeDescriptions = {};

        service.getAllCriterias()
            .then(function (criterias) {

                $scope.byLookupTypeDescription = _.groupBy(criterias, 'RiskLookupAssessmentTypeDescription');
            });

        $scope.getRatings = function (lookupTypDescription) {
            return byLookupTypeDescription[lookupTypDescription];
        }
    }
})();